/**
 * A Google Maps search for `query` — a place name and address, or
 * "latitude,longitude". Opens the map app on mobile and the site on web.
 */
export const getMapSearchUrl = (query: string): string =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
